import { useMemo } from "react";
import { QRProps } from "@/contexts/QREditorContext/types";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";

export type UrlPreviewProps = QRProps<"url"> | QRProps<"url-static">;

export function useUrlData(props: UrlPreviewProps) {
  const { data, isInitPreview } = usePreviewData(props as QRProps<"url">, {
    prioritizeContext: props.preview === true,
  });

  const qrUrlLink = useMemo(() => {
    return data?.qrUrlLink || "";
  }, [data?.qrUrlLink]);

  const translationKey = props.type;

  const translations = useMemo(() => {
    return {
      title1: props.previewTranslations?.[translationKey]?.preview_url_title_1,
      title2: props.previewTranslations?.[translationKey]?.preview_url_title_2,
    };
  }, [props.previewTranslations, translationKey]);

  return {
    qrUrlLink,
    translations,
    isInitPreview,
    preview: props.preview,
  };
}
